var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { usePermittedActionsList } from '@data/permission/permissionActions';
import { tagsApi } from '@data/rest/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addQueryClientArrayMember, removeQueryClientArrayMember, updateQueryClientArrayMember, addMultipleQueryClientArrayMembers, updateMultipleQueryClientArrayMembers, removeMultipleQueryClientArrayMembers, } from '@util/query';
import toast from 'react-hot-toast';
import { move } from '@util/array';
import { InternalTagType, RollupType, TagType, } from '@common/api';
import { useTagContext } from './tagContext';
import { TagQueryKeys } from './types';
import { handleApiErrorMessage } from '../../util/message';
import { sheetRowKeys } from '../sheetRow/sheetRowActions';
import { reorder } from '../../util/sort';
function getTagActions() {
    return tagsApi.actions();
}
function toActionsByTagIdMap(map, tag) {
    map[tag.id] = tag;
    return map;
}
function createActionsByTagIdMap(data) {
    return data.reduce(toActionsByTagIdMap, {});
}
export function useActionsByTagIdMap() {
    return usePermittedActionsList(TagQueryKeys.Actions, getTagActions, { select: createActionsByTagIdMap });
}
export function useTagActions() {
    var _this = this;
    var queryClient = useQueryClient();
    var tagData = useTagContext().tagData;
    var allSearches = sheetRowKeys.searches();
    var updateMutation = useMutation(function (tag) { return tagsApi.update(tag.id, tag); }, {
        onMutate: function (tag) { return __awaiter(_this, void 0, void 0, function () {
            var previousTags;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(TagQueryKeys.Tags)];
                    case 1:
                        _a.sent();
                        previousTags = queryClient.getQueryData(TagQueryKeys.Tags);
                        updateQueryClientArrayMember(queryClient, TagQueryKeys.Tags, tag);
                        return [2 /*return*/, previousTags];
                }
            });
        }); },
        onError: function (error, variables, context) {
            queryClient.setQueryData(TagQueryKeys.Tags, context);
            handleApiErrorMessage(error);
        },
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.invalidateQueries(TagQueryKeys.Tags)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var updateBatchMutation = useMutation(function (tagUpdates) { return tagsApi.updateBatch(tagUpdates); }, {
        onMutate: function (updates) { return __awaiter(_this, void 0, void 0, function () {
            var previousTags, updater;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(TagQueryKeys.Tags)];
                    case 1:
                        _a.sent();
                        previousTags = queryClient.getQueryData(TagQueryKeys.Tags);
                        updater = function (tags) {
                            var e_1, _a;
                            if (tags === undefined) {
                                return;
                            }
                            var updatedMap = new Map(updates.map(function (u) { return [u.id, u]; }));
                            var mutated = [];
                            try {
                                for (var tags_1 = __values(tags), tags_1_1 = tags_1.next(); !tags_1_1.done; tags_1_1 = tags_1.next()) {
                                    var tag = tags_1_1.value;
                                    var updatedTag = updatedMap.get(tag.id);
                                    if (updatedTag !== undefined) {
                                        mutated.push(__assign({}, updatedTag));
                                    }
                                    else {
                                        mutated.push(tag);
                                    }
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (tags_1_1 && !tags_1_1.done && (_a = tags_1.return)) _a.call(tags_1);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                            return mutated;
                        };
                        queryClient.setQueryData(TagQueryKeys.Tags, updater);
                        return [2 /*return*/, previousTags];
                }
            });
        }); },
        onError: function (error, variables, context) {
            queryClient.setQueryData(TagQueryKeys.Tags, context);
            handleApiErrorMessage(error);
        },
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.invalidateQueries(TagQueryKeys.Tags)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var reorderMutation = useMutation(function (data) {
        return tagsApi.sort(data.pId, data.tagsSort);
    }, {
        onMutate: function (_a) {
            var pId = _a.pId, tagsSort = _a.tagsSort, id = _a.id, order = _a.order;
            return __awaiter(_this, void 0, void 0, function () {
                var updatedTags, tagsSort_1, tagsSort_1_1, ts, find, targetTag, searches, searches_1, searches_1_1, _b, key, data, targetIdx, generatedTags, reorderedTags, childrenCopy;
                var e_2, _c, e_3, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0: return [4 /*yield*/, queryClient.cancelQueries(TagQueryKeys.Tags)];
                        case 1:
                            _e.sent();
                            updatedTags = [];
                            try {
                                for (tagsSort_1 = __values(tagsSort), tagsSort_1_1 = tagsSort_1.next(); !tagsSort_1_1.done; tagsSort_1_1 = tagsSort_1.next()) {
                                    ts = tagsSort_1_1.value;
                                    find = tagData.tagById[ts.id];
                                    if (find) {
                                        updatedTags.push(__assign(__assign({}, find), { order: ts.order }));
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (tagsSort_1_1 && !tagsSort_1_1.done && (_c = tagsSort_1.return)) _c.call(tagsSort_1);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                            targetTag = tagData.tagById[id];
                            if (!targetTag) {
                                return [2 /*return*/];
                            }
                            searches = queryClient.getQueriesData(allSearches);
                            try {
                                for (searches_1 = __values(searches), searches_1_1 = searches_1.next(); !searches_1_1.done; searches_1_1 = searches_1.next()) {
                                    _b = __read(searches_1_1.value, 2), key = _b[0], data = _b[1];
                                    if (!data) {
                                        continue;
                                    }
                                    targetIdx = data.children.findIndex(function (c) { return c.generated.includes(id); });
                                    if (targetIdx === -1) {
                                        continue;
                                    }
                                    generatedTags = data.children[targetIdx].generated
                                        .map(function (id) { return tagData.tagById[id]; })
                                        .filter(function (t) { return t !== undefined; });
                                    reorderedTags = reorder(generatedTags, targetTag, order);
                                    childrenCopy = __spreadArray([], __read(data.children), false);
                                    childrenCopy[targetIdx] = __assign(__assign({}, data.children[targetIdx]), { generated: reorderedTags.map(function (t) { return t.id; }) });
                                    queryClient.setQueryData(key, __assign(__assign({}, data), { children: childrenCopy }));
                                }
                            }
                            catch (e_3_1) { e_3 = { error: e_3_1 }; }
                            finally {
                                try {
                                    if (searches_1_1 && !searches_1_1.done && (_d = searches_1.return)) _d.call(searches_1);
                                }
                                finally { if (e_3) throw e_3.error; }
                            }
                            updateMultipleQueryClientArrayMembers(queryClient, TagQueryKeys.Tags, updatedTags);
                            return [2 /*return*/];
                    }
                });
            });
        },
    });
    var deleteMutation = useMutation(function (id) { return tagsApi._delete(id); }, {
        onMutate: function (id) { return __awaiter(_this, void 0, void 0, function () {
            var previousTags;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(TagQueryKeys.Tags)];
                    case 1:
                        _a.sent();
                        previousTags = queryClient.getQueryData(TagQueryKeys.Tags);
                        removeQueryClientArrayMember(queryClient, TagQueryKeys.Tags, id);
                        return [2 /*return*/, previousTags];
                }
            });
        }); },
        onError: function (error, variables, context) {
            queryClient.setQueryData(TagQueryKeys.Tags, context);
            handleApiErrorMessage(error);
        },
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.invalidateQueries(TagQueryKeys.Tags)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var deleteBatchMutation = useMutation(function (ids) { return tagsApi.deleteBatch({ ids: ids }); }, {
        onMutate: function (ids) { return __awaiter(_this, void 0, void 0, function () {
            var previousTags;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(TagQueryKeys.Tags)];
                    case 1:
                        _a.sent();
                        previousTags = queryClient.getQueryData(TagQueryKeys.Tags);
                        removeMultipleQueryClientArrayMembers(queryClient, TagQueryKeys.Tags, ids);
                        return [2 /*return*/, previousTags];
                }
            });
        }); },
        onError: function (error, variables, context) {
            queryClient.setQueryData(TagQueryKeys.Tags, context);
            handleApiErrorMessage(error);
        },
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.invalidateQueries(TagQueryKeys.Tags)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var deleteChildrenTagsMutation = useMutation(function (parentId) { return tagsApi.deleteChildren(parentId); }, {
        onMutate: function (parentId) { return __awaiter(_this, void 0, void 0, function () {
            var cTags, ids;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(TagQueryKeys.Tags)];
                    case 1:
                        _a.sent();
                        cTags = tagData.tagsByParentId[parentId] || [];
                        ids = cTags === null || cTags === void 0 ? void 0 : cTags.map(function (t) { return t.id; });
                        removeMultipleQueryClientArrayMembers(queryClient, TagQueryKeys.Tags, ids);
                        return [2 /*return*/];
                }
            });
        }); },
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.invalidateQueries(TagQueryKeys.Tags)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    });
    function trimTagRepresentation(formData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var request;
        if (formData.type === TagType.Account) {
            request = {
                id: formData.id,
                type: formData.type,
                topDownEnabled: formData.topDownEnabled,
                rollupType: formData.rollupType,
                name: formData.name.trim(),
                ParentId: formData.ParentId,
                description: (_b = (_a = formData.description) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : null,
                connectedTagIds: formData.connectedTagIds,
                dimensionTagIds: formData.dimensionTagIds,
                expression: (_d = (_c = formData.expression) === null || _c === void 0 ? void 0 : _c.trim()) !== null && _d !== void 0 ? _d : null,
                jsonData: formData.jsonData,
                active: formData.active,
                order: formData.order,
                numberFormat: (_e = formData.numberFormat) !== null && _e !== void 0 ? _e : null,
                dataType: formData.dataType,
                topDownMapping: (_f = formData.topDownMapping) !== null && _f !== void 0 ? _f : null,
                optimizeCalculation: formData.optimizeCalculation,
                toAccountTagId: formData.toAccountTagId,
                toVersionTagId: formData.toVersionTagId,
                fromVersionTagId: formData.fromVersionTagId,
                readonly: formData.readonly,
                calculateOnDemand: formData.calculateOnDemand,
                zConstraint: formData.zConstraint,
            };
        }
        else if (formData.type === TagType.Dimension) {
            request = {
                id: formData.id,
                type: formData.type,
                name: formData.name.trim(),
                ParentId: formData.ParentId,
                description: (_h = (_g = formData.description) === null || _g === void 0 ? void 0 : _g.trim()) !== null && _h !== void 0 ? _h : null,
                expression: (_k = (_j = formData.expression) === null || _j === void 0 ? void 0 : _j.trim()) !== null && _k !== void 0 ? _k : null,
                jsonData: formData.jsonData,
                active: formData.active,
                order: formData.order,
            };
        }
        else {
            request = {
                id: formData.id,
                type: formData.type,
                name: formData.name.trim(),
                ParentId: formData.ParentId,
                description: null,
                jsonData: formData.jsonData,
                active: formData.active,
                order: formData.order,
            };
        }
        return request;
    }
    return {
        editTag: function editTag(formData) {
            return __awaiter(this, void 0, void 0, function () {
                var request, existingTag;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            request = trimTagRepresentation(formData);
                            existingTag = tagData.getTagByNameAndParent(request.name, request.ParentId);
                            if (!(existingTag && existingTag.id !== formData.id)) return [3 /*break*/, 1];
                            throw new Error('Tag with the same name already exists');
                        case 1: return [4 /*yield*/, updateMutation.mutateAsync(request)];
                        case 2: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        batchEditTags: function batchEditTags(tags) {
            return __awaiter(this, void 0, void 0, function () {
                var requests;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            requests = tags.map(function (t) { return trimTagRepresentation(t); });
                            return [4 /*yield*/, updateBatchMutation.mutateAsync(requests)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        editTagJsonData: function editTagJsonData(id, newJsonData) {
            return __awaiter(this, void 0, void 0, function () {
                var tag, updateTagJsonDataRequest;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            tag = tagData.tagById[id];
                            if (!(tag !== undefined)) return [3 /*break*/, 2];
                            updateTagJsonDataRequest = __assign(__assign({}, tag), { connectedTagIds: tag.connectedTagIds || [], jsonData: newJsonData });
                            return [4 /*yield*/, updateMutation.mutateAsync(updateTagJsonDataRequest)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        },
        reorderTags: function reorderTags(items, itemId, destinationIdx) {
            return __awaiter(this, void 0, void 0, function () {
                var targetItemIdx, targetItem, tag, orderedItems, tagsSort, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            targetItemIdx = items.findIndex(function (i) { return i.tagId === itemId; });
                            if (targetItemIdx === -1) {
                                return [2 /*return*/];
                            }
                            targetItem = items[targetItemIdx];
                            tag = targetItem.tagId ? tagData.tagById[targetItem.tagId] : null;
                            if ((tag === null || tag === void 0 ? void 0 : tag.internalType) === InternalTagType.Year) {
                                toast.error("Year tags can't be reordered.");
                                return [2 /*return*/];
                            }
                            orderedItems = move(items, { fromIdx: targetItemIdx, toIdx: destinationIdx });
                            if (!targetItem.parentTagId) {
                                return [2 /*return*/];
                            }
                            tagsSort = orderedItems
                                .filter(function (i) { return i.parentTagId === targetItem.parentTagId; })
                                .map(function (_a, idx) {
                                var tagId = _a.tagId;
                                return ({ id: tagId, order: idx });
                            });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, reorderMutation.mutateAsync({
                                    pId: targetItem.parentTagId,
                                    tagsSort: tagsSort,
                                    id: itemId,
                                    order: destinationIdx,
                                })];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            toast.error('Error reordering tags', err_1.message);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        deleteTagData: function deleteTagData(id) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, tagsApi.deleteData(id)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        deleteTag: function deleteTag(id) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, deleteMutation.mutateAsync(id)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        batchDeleteTags: function deleteTagsBatch(ids) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, deleteBatchMutation.mutateAsync(ids)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        deleteTagChildren: function deleteTagChildren(id) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    deleteChildrenTagsMutation.mutateAsync(id);
                    return [2 /*return*/];
                });
            });
        },
        createMaterializedAccountTag: function createMaterializedAccountTag(name, parentId) {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, Promise, function () {
                var parent, parentTagId, tagName, index, existingTag, siblings, order, monthsId, yearsId, versionsId, createTagRequest, createdTag, err_2;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            _e.trys.push([0, 2, , 3]);
                            parent = tagData.tagsByLowercase['variables'];
                            parentTagId = parentId ? parentId : parent && parent.length > 0 ? parent[0].id : null;
                            tagName = name;
                            index = 1;
                            while (true) {
                                existingTag = tagData.getTagByNameAndParent(tagName, parentTagId);
                                if (!existingTag) {
                                    break;
                                }
                                tagName = "".concat(name, " ").concat(index);
                                index++;
                            }
                            siblings = tagData.tagsByParentId[parentTagId !== null && parentTagId !== void 0 ? parentTagId : 'null'];
                            order = (_a = siblings === null || siblings === void 0 ? void 0 : siblings.reduce(function (order, t) { return (t.order > order ? t.order : order); }, 0)) !== null && _a !== void 0 ? _a : 0;
                            monthsId = (_b = tagData.internalTagsMap.months) === null || _b === void 0 ? void 0 : _b[0].ParentId;
                            yearsId = (_c = tagData.internalTagsMap.years) === null || _c === void 0 ? void 0 : _c[0].ParentId;
                            versionsId = (_d = tagData.internalTagsMap.versions) === null || _d === void 0 ? void 0 : _d[0].ParentId;
                            if (!monthsId || !yearsId || !versionsId) {
                                throw new Error('Unable to find internal tags');
                            }
                            createTagRequest = {
                                name: tagName,
                                ParentId: parentTagId,
                                type: TagType.Account,
                                rollupType: RollupType.Sum,
                                connectedTagIds: [],
                                description: null,
                                dimensionTagIds: [monthsId, yearsId, versionsId],
                                jsonData: null,
                                topDownEnabled: false,
                                order: order + 1,
                            };
                            return [4 /*yield*/, tagsApi.create(createTagRequest)];
                        case 1:
                            createdTag = _e.sent();
                            if (createdTag) {
                                addQueryClientArrayMember(queryClient, TagQueryKeys.Tags, createdTag);
                                queryClient.invalidateQueries(TagQueryKeys.Tags);
                                queryClient.invalidateQueries(TagQueryKeys.Actions);
                                return [2 /*return*/, createdTag];
                            }
                            else {
                                return [2 /*return*/, null];
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            err_2 = _e.sent();
                            toast.error('Error adding tag', err_2.message);
                            return [2 /*return*/, null];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        createTag: function createTag(newTag) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var existingTag, siblings, order, createTagRequest, createdTag, err_3;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 2, , 3]);
                            existingTag = tagData.getTagByNameAndParent(newTag.name, newTag.ParentId);
                            if (existingTag) {
                                throw new Error('Tag with the same name already exists');
                            }
                            siblings = newTag.ParentId
                                ? tagData.tagsByParentId[newTag.ParentId] || []
                                : tagData.tagsByParentId['null'] || [];
                            order = ((_a = siblings[siblings.length - 1]) === null || _a === void 0 ? void 0 : _a.order) || 0;
                            createTagRequest = {
                                name: newTag.name,
                                ParentId: newTag.ParentId,
                                type: newTag.type ? newTag.type : TagType.Group,
                                rollupType: newTag.type === TagType.Dimension ? undefined : RollupType.Sum,
                                connectedTagIds: (newTag === null || newTag === void 0 ? void 0 : newTag.connectedTagIds) || [],
                                dimensionTagIds: (newTag === null || newTag === void 0 ? void 0 : newTag.dimensionTagIds) || [],
                                topDownEnabled: (newTag === null || newTag === void 0 ? void 0 : newTag.topDownEnabled) || false,
                                description: (_c = (_b = newTag.description) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : null,
                                jsonData: null,
                                order: order + 1,
                            };
                            return [4 /*yield*/, tagsApi.create(createTagRequest)];
                        case 1:
                            createdTag = _d.sent();
                            if (createdTag) {
                                addQueryClientArrayMember(queryClient, TagQueryKeys.Tags, createdTag);
                                queryClient.invalidateQueries(TagQueryKeys.Tags);
                                queryClient.invalidateQueries(TagQueryKeys.Actions);
                                return [2 /*return*/, createdTag];
                            }
                            else {
                                return [2 /*return*/, null];
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            err_3 = _d.sent();
                            toast.error('Error adding tag', err_3.message);
                            return [2 /*return*/, null];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        batchCreateTags: function batchCreateTags(newTags) {
            return __awaiter(this, void 0, void 0, function () {
                var createTagRequests, createdTags, err_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 4]);
                            createTagRequests = newTags.map(function (newTag) {
                                var _a, _b, _c, _d;
                                var siblings = newTag.ParentId
                                    ? tagData.tagsByParentId[newTag.ParentId] || []
                                    : tagData.tagsByParentId['null'] || [];
                                var order = ((_a = siblings[siblings.length - 1]) === null || _a === void 0 ? void 0 : _a.order) || 0;
                                return {
                                    name: newTag.name,
                                    ParentId: newTag.ParentId,
                                    type: newTag.type || TagType.Group,
                                    rollupType: RollupType.Sum,
                                    connectedTagIds: [],
                                    description: (_c = (_b = newTag.description) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : null,
                                    jsonData: (_d = newTag.jsonData) !== null && _d !== void 0 ? _d : null,
                                    order: order + 1,
                                    dimensionTagIds: newTag.dimensionTagIds,
                                };
                            });
                            return [4 /*yield*/, tagsApi.createBatch(createTagRequests)];
                        case 1:
                            createdTags = _a.sent();
                            if (createdTags && createdTags.length > 0) {
                                addMultipleQueryClientArrayMembers(queryClient, TagQueryKeys.Tags, createdTags);
                                queryClient.invalidateQueries(TagQueryKeys.Tags);
                                queryClient.invalidateQueries(TagQueryKeys.Actions);
                            }
                            return [3 /*break*/, 4];
                        case 2:
                            err_4 = _a.sent();
                            return [4 /*yield*/, handleApiErrorMessage(err_4)];
                        case 3:
                            _a.sent();
                            return [2 /*return*/, null];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
    };
}
